export default __webpack_public_path__ + "static/3-e0e308fc27099cb5a115c424be65c34d.png";